// extracted by mini-css-extract-plugin
export default {"ratingList":"ResponsiblesRating_ratingList__Lhjwi","list":"ResponsiblesRating_list__JaBc4","empty":"ResponsiblesRating_empty__k3V+t"};